import React from 'react'
import TaskCardSettingBar from '../TaskCardModal2023/TaskCardSettingBar/TaskCardSettingBar'
import Subtask2023 from '../TaskCardModal2023/Subtask2023/Subtask2023'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../AdminTasks/adminTaskUtils'
import { baseUrl } from '../assets/Animations'
import axios from 'axios'
import './workflow-card-modal-2023.css'
import LooksLikeYouAreDonePopup from './LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const WorkflowCardModal2023 = ({openWorkflowModal2023, setOpenWorkflowModal2023, setWorkflows, setShowNotes}) => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    React.useEffect(() => taskCardAnimateIn('workflow-card-modal-2023__wrapper', 'workflow-card-modal-2023'), [])

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: ''})
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('workflow-card-modal-2023__wrapper', 'workflow-card-modal-2023')
        axios.put(`${baseUrl}/workflows/${openWorkflowModal2023.todoId}`, openWorkflowModal2023, myHeader)
        .then((res) => {
            setWorkflows(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    const deleteAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('workflow-card-modal-2023__wrapper', 'workflow-card-modal-2023')
        axios.delete(`${baseUrl}/workflows/${openWorkflowModal2023.todoId}`, myHeader)
        .then((res) => {
            setWorkflows(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setOpenWorkflowModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    return(
        <div className='workflow-card-modal-2023__wrapper' id='workflow-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'workflow-card-modal-2023__wrapper' && (openWorkflowModal2023.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setIsPopupOpen(true))}>
            {isPopupOpen && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='workflow-card-modal-2023' id='workflow-card-modal-2023'>
                <input className='workflow-card-modal-2023__task-name' value={openWorkflowModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openWorkflowModal2023} setOpenModal2023={setOpenWorkflowModal2023} />
                <div className='workflow-card-modal-2023__subtask__wrapper'>
                    {openWorkflowModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setOpenWorkflowModal2023} />)}
                    <div className='workflow-card-modal-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...openWorkflowModal2023, todoSubtasks: [...openWorkflowModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                </div>
            </div>
        </div>
    )
}
export default WorkflowCardModal2023